/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { h } from 'preact';
import { dashToPascalCase, isEventProp, normalizeEventPropName } from './utils';
export function createPreactComponent({ tagName, defaultProps, defineCustomElement, }) {
    let isRegistered = false;
    const PreactComponent = (props) => {
        if (!isRegistered) {
            if (defineCustomElement !== undefined) {
                defineCustomElement();
                isRegistered = true;
            }
        }
        const propsToPass = Object.entries(props).reduce((acc, [propName, propValue]) => {
            if (isEventProp(propName)) {
                return Object.assign(Object.assign({}, acc), { [`${normalizeEventPropName(propName)}`]: propValue });
            }
            return Object.assign(Object.assign({}, acc), { [propName]: propValue });
        }, {});
        return h(tagName, Object.assign(Object.assign({}, defaultProps), propsToPass));
    };
    PreactComponent.displayName = `${dashToPascalCase(tagName)}`;
    return PreactComponent;
}
